export default "__VITE_ASSET__36p3BgLP__"